// extracted by mini-css-extract-plugin
export default {"main":"LoginLayout_main__jlT8b","left":"LoginLayout_left__vaGwE","right":"LoginLayout_right__z94By","form":"LoginLayout_form__lr5UK"};